<template>
  <div :class="[wrapperClass]">
    <div :class="containerClass">
      <div :class="['tw:absolute tw:top-0 tw:left-0 tw:w-1/3 tw:bg-black tw:rounded', lineHeightClass]"></div>
      <div :class="['tw:absolute tw:top-0 tw:left-0 tw:h-1/3 tw:bg-black tw:rounded', lineWidthClass]"></div>
      <div :class="['tw:absolute tw:top-0 tw:right-0 tw:w-1/3 tw:bg-black tw:rounded', lineHeightClass]"></div>
      <div :class="['tw:absolute tw:top-0 tw:right-0 tw:h-1/3 tw:bg-black tw:rounded', lineWidthClass]"></div>
      <div :class="['tw:absolute tw:bottom-0 tw:left-0 tw:w-1/3 tw:bg-black tw:rounded', lineHeightClass]"></div>
      <div :class="['tw:absolute tw:bottom-0 tw:left-0 tw:h-1/3 tw:bg-black tw:rounded', lineWidthClass]"></div>
      <div :class="['tw:absolute tw:bottom-0 tw:right-0 tw:w-1/3 tw:bg-black tw:rounded', lineHeightClass]"></div>
      <div :class="['tw:absolute tw:bottom-0 tw:right-0 tw:h-1/3 tw:bg-black tw:rounded', lineWidthClass]"></div>
      <div
        class="tw:absolute tw:top-1/2 tw:left-1/2 tw:w-1/3 tw:h-1/3 tw:bg-red-500 tw:rounded-full tw:transform tw:-translate-x-1/2 tw:-translate-y-1/2 tw:animate-blink"
      ></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

type Size = "small" | "medium" | "large";

interface Props {
  size?: Size;
  showBackground?: boolean;
}

const { size = "large", showBackground = true } = defineProps<Props>();

const wrapperClass = computed(() => {
  const baseClass = "tw:flex tw:justify-center";
  return showBackground ? `${baseClass} tw:bg-white` : baseClass;
});

const containerClass = computed(() => {
  const baseClass = "tw:relative";
  if (size === "small") return `${baseClass} tw:w-4 tw:h-4`;
  if (size === "medium") return `${baseClass} tw:w-6 tw:h-6`;
  return `${baseClass} tw:w-8 tw:h-8 tw:sm:w-10 tw:sm:h-10`;
});

const lineHeightClass = computed(() => {
  if (size === "small") return "tw:h-0.5";
  if (size === "medium") return "tw:h-[0.125rem]";
  return "tw:h-[0.1875rem]";
});

const lineWidthClass = computed(() => {
  if (size === "small") return "tw:w-0.5";
  if (size === "medium") return "tw:w-[0.125rem]";
  return "tw:w-[0.1875rem]";
});
</script>
